import { t } from 'i18next'
import * as yup from 'yup'

const requiredTranslated = () =>
  t('common:validations.required', {
    defaultValue: 'Este campo é obrigatório'
  })

const dimensionRangeTranslated = () =>
  t('common:validations.dimensionRange', {
    defaultValue: 'Informe um valor numérico maior que zero'
  })

const SPONSORED_BRAND_TYPES = new Set([
  'sponsored_brand_image',
  'sponsored_brand_video'
])

const isValidDimensionForType = (
  value: string | undefined,
  type: string | undefined
) => {
  if (!type || !SPONSORED_BRAND_TYPES.has(type)) return true
  if (!value) return true

  const numericValue = Number(value)
  return /^\d+$/.test(value) && numericValue > 0
}

export const adSizeSchema = yup.object().shape({
  name: yup.string().required(requiredTranslated),
  label: yup.string(),
  width: yup
    .string()
    .required(requiredTranslated)
    .test('dimension-range', dimensionRangeTranslated, function (value) {
      return isValidDimensionForType(value, this.parent.type)
    }),
  height: yup
    .string()
    .required(requiredTranslated)
    .test('dimension-range', dimensionRangeTranslated, function (value) {
      return isValidDimensionForType(value, this.parent.type)
    }),
  type: yup
    .string()
    .oneOf([
      'video',
      'image',
      'digital_signage',
      'sponsored_brand_image',
      'sponsored_brand_video'
    ])
    .required(requiredTranslated)
})
